'use strict';

var angular = require('angular');
var _ = require('lodash');
var MarketProductGroupController = function MarketProductGroupController($scope, $rootScope, $state, $controller, dataRetrieverConstantsService, dataRetrieverService, $q, marketAnalysisPanelService, userPreferencesService, applicableSeasonsLoadingService, searchCriteriaRsqlQueryService) {
  $scope.markFilterChanged = false;
  $scope.marketProductViewReady = $q.defer();
  $scope.mode = dataRetrieverConstantsService.MARKET_PRODUCT_GROUP_MODE;
  $scope.kpiRibbonCollapsed = userPreferencesService.getUserSettingComponent('collapseKpis');
  $scope.showKpiTarget = userPreferencesService.getUserSettingComponent('showKpiTarget');
  angular.extend(this, $controller('AnalysisModeController', {
    $scope: $scope
  }));
  var marketProductGroupDataRetriever = dataRetrieverService.getDataRetriever($scope.screen, $scope.mode);
  var historyDrawerRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, dataRetrieverConstantsService.ADJUSTMENT_HISTORY_MODE);
  function emitOneDaySelected(brushSelectionFilter) {
    if (brushSelectionFilter.filterType === 'dateRange') {
      $scope.$broadcast('market-analysis:oneDaySelected', isOneDaySelected(brushSelectionFilter));
    }
  }
  function isOneDaySelected(brushSelectionFilter) {
    if (!brushSelectionFilter.isEmpty()) {
      var filterArguments = brushSelectionFilter.filterArguments[0];
      return filterArguments[0].from.valueOf() === filterArguments[0].to.valueOf();
    }
  }
  $scope.onBrushFilter = function (event, brushSelectionFilter) {
    emitOneDaySelected(brushSelectionFilter);
    emitOneMarketSelected(brushSelectionFilter);
  };
  $scope.onRowSelection = function (event, selectedRows, gridId, allRows) {
    var oneMarketSelected = selectedRows.length > 0 ? _.uniqBy(selectedRows, 'market').length === 1 : !_.isUndefined(allRows) && _.uniqBy(allRows, 'market').length === 1;
    $rootScope.$broadcast('market-product-group:rowSelected', oneMarketSelected);
  };
  function emitOneMarketSelected(brushSelectionFilter) {
    if (brushSelectionFilter.filterType === 'markets') {
      var isOneMarketSelected = brushSelectionFilter.barsWithData.length === 1;
      $rootScope.$broadcast('market-product-group:rowSelected', isOneMarketSelected);
      $scope.$broadcast('market-analysis:oneMarketSelected', isOneMarketSelected);
    }
  }
  $scope.$on('brush-filter:filterApplied', $scope.onBrushFilter);
  $scope.$on('market-product-group:filterUpdated', function () {
    if (!$scope.markFilterChanged) {
      $scope.markFilterChanged = true;
      $scope.marketProductViewReady.reject();
      $scope.marketProductViewReady = $q.defer();
      var marketProductReadyPromise = $scope.marketProductViewReady.promise;
      marketProductReadyPromise.then($scope.setSearchRule);
    }
  });
  $scope.setSearchRule = function () {
    $scope.markFilterChanged = false;
    var marketProductGroupFilter = !_.isEmpty($scope.screenState.selectedRows) ? $scope.screenState.selectedRows : $scope.filterData;
    var searchRule = marketAnalysisPanelService.buildMarketProductSearchRule(marketProductGroupFilter);
    var markets = $scope.filterData && $scope.filterData.markets;
    applicableSeasonsLoadingService.loadApplicableSeasons(markets, dataRetrieverConstantsService.MARKET_SCREEN);
    if (!_.isEqual(searchRule, marketProductGroupDataRetriever.getSearchCriteriaRules())) {
      //overwrite the stored dataRetriever and clear the previous state
      marketProductGroupDataRetriever.setScenarioAppendFunction(searchCriteriaRsqlQueryService.appendScenarioNameToMarketProductRule);
      marketProductGroupDataRetriever.setCustomSearchCriteriaRules(searchRule);
      marketProductGroupDataRetriever.selectedDimension($scope.screenState.dimension);
      historyDrawerRetriever.setCustomSearchCriteriaRules(searchRule);
    }
    $scope.dataReady = true;
    $scope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.setMarketProductViewReady = function (ready) {
    if (ready) {
      $scope.marketProductViewReady.resolve();
    }
  };
  $scope.screenState.isMarketProductGridExpanded = undefined === $scope.screenState.isMarketProductGridExpanded ? userPreferencesService.getUserSettingComponent('isMarketProductGridExpanded') : false;
  $scope.$on('gridExpand:market-product-group-analysis', function () {
    $scope.screenState.isMarketProductGridExpanded = !$scope.screenState.isMarketProductGridExpanded;
  });
};
MarketProductGroupController.$inject = ['$scope', '$rootScope', '$state', '$controller', 'DataRetrieverConstantsService', 'DataRetrieverService', '$q', 'MarketAnalysisPanelService', 'UserPreferencesService', 'ApplicableSeasonsLoadingService', 'SearchCriteriaRsqlQueryService'];
module.exports = MarketProductGroupController;